import { ActionContext } from 'vuex';
import DataService from '/@/service/DataService';

const _state: {
	loading: boolean;

	siteDataVersion: number;
	siteData?: any;
	categories?: any[];
	categoriesFeatured?: any[];

	productModal: string;
} = {
	loading: false,

	siteDataVersion: 0,
	siteData: undefined,
	categories: undefined,
	categoriesFeatured: undefined,

	productModal: '',
};

type State = typeof _state;



const fetching: any = {};



export const ConfigModule = {
	namespaced: true,

	state: _state,

	getters: {
		GET_LOADING: (state: State) => {
			return state.loading;
		},

		GET_SITE_DATA: (state: State) => {
			return state.siteData;
		},
	},

	actions: {
		FETCH_SITE_DATA: (context: ActionContext<State, State>) => {
			if (!fetching.FETCH_SITE_DATA) {
				fetching.FETCH_SITE_DATA = true;

				DataService.site.getSiteData(context.state.siteDataVersion)
					.then((response) => {
						context.commit('SET_SITE_DATA', response.data.data);
					})
					.catch((err) => {
						console.log(err);
					})
					.finally(() => {
						delete fetching.FETCH_SITE_DATA;
					});
			}
		},

		CLEAR_STORE: (context: ActionContext<State, State>) => {
			context.commit('SET_SITE_DATA', undefined);
		},
	},

	mutations: {
		SET_LOADING: (state: State, loading: boolean) => {
			state.loading = loading;
		},
		SET_SITE_DATA: (state: State, payload: any) => {
			if (payload === undefined) {
				state.siteDataVersion++;
				state.siteData = undefined;
			} else {
				state.siteData = {
					...payload,
				};
			}
		},
	},
};
